/**
 * Created by Макс on 01.11.2017.
 */
/**
 * Created by Макс on 01.11.2017.
 */
import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'dealer-edit-rootftop-comp',
    templateUrl: 'edit-rootftop/index.html',
    styleUrls: ['add-access/bootstrap.min.css','add-access/update.css','add-access/style.css'], //left-menu/style.min.css
})
export class DealerEditRootftopComponent {
    constructor(
        private broadcaster: Broadcaster,
        private elRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-edit-rootftop.component.ts